import { TypeSameDoctors } from '../aboutdoctor/types/TypesDocsId';
import { formatNameDoctor } from '@/constant/scripts';
import { IoLocationOutline } from 'react-icons/io5';
import LoadingLink from '../LoadingLink';
import Link from 'next/link';
import { FaStar } from 'react-icons/fa';
import Image from 'next/image';

function CardSimlarDoctor(props: TypeSameDoctors) {
    const { otherDoc, name } = props;

    return (
        <div className="bg-white shadow-m rounded-2xl !p-6 flex gap-3 flex-col">
            <h3
                id="sames_doctors"
                className="font-semibold pb-2 flex gap-2 items-center"
            >
                {`پزشکان مشابه دکتر ${name}`}
            </h3>
            {otherDoc.map((item) => (
                <SimilarCard {...item} key={item.id} />
            ))}
        </div>
    );
}

export default CardSimlarDoctor;

export function SimilarCard(props: {
    id: number;
    name: string;
    doctor_image: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    specialty: any;
    state?: string;
    visit_count?: number;
    rate?: number;
    first?: string;
    address?: string;
}) {
    const {
        id,
        name,
        doctor_image,
        specialty,
        state,
        // first,
        rate,
        // visit_count
        address,
    } = props;

    return (
        <Link
            href={`/doctor/${id}/${formatNameDoctor(name)}`}
            className="w-full block hover:opacity-75 transition-opacity bg-primary-shaded rounded-2xl relative p-3"
        >
            <div className="flex gap-4 items-center">
                <Image
                    alt={`${name}`}
                    width={1000}
                    height={1000}
                    src={
                        doctor_image
                            ? process.env.NEXT_PUBLIC_STATIC_URL + doctor_image
                            : ''
                    }
                    className="rounded-2xl size-[64px] self-start object-cover"
                />
                <div className="!w-full gap-1 flex-col flex">
                    <p className="font-bold text-sm md:!text-base">{name}</p>
                    {typeof specialty === 'object'
                        ? specialty?.name
                        : specialty}
                </div>
            </div>
            {state || address ? (
                <div className="gap-[2px] flex items-top text-right pt-3">
                    <IoLocationOutline className="font-bold text-[#4A4A4A] mt-1 text-sm" />
                    <p className="text-sm">
                        {state ? state : ''}{' '}
                        {address ? `${state ? '-' : ''} ` + address : ''}
                    </p>
                </div>
            ) : (
                ''
            )}
            {rate ? (
                <div className="absolute left-3 top-3 flex gap-1">
                    <FaStar className="text-orange-500 mt-[1px] text-base" />{' '}
                    <p className="font-medium">{rate}</p>{' '}
                </div>
            ) : (
                ''
            )}
            <div className="flex justify-end w-full">
                <div className="w-full">
                    <LoadingLink className="mr-auto w-full hover:!opacity-70 !transition-opacity !bg-primary-shaded !py-2 !h-9 mt-2" />
                </div>
            </div>
        </Link>
    );
}
